import React from "react";
import styles from "./footer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhoneAlt, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Logo and Description */}
        <div className={styles.footerLogoSection}>
          <h3 className={styles.logo}>MaidMatch</h3>
          <p className={styles.description}>
            Connecting you to reliable house managers and house girls. Your perfect match for household assistance is just a click away.
          </p>
        </div>

        {/* Quick Links */}
        <div className={styles.footerLinks}>
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/findhousegirl/">Find House Girl</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className={styles.footerContact}>
          <h4>Contact Us</h4>
          <p><FontAwesomeIcon icon={faEnvelope} /> support@maidmatch.com</p>
          <p><FontAwesomeIcon icon={faPhoneAlt} /> +254 701 496 724</p>
          <p><FontAwesomeIcon icon={faMapMarkerAlt} /> Roysambu, Nairobi, Kenya</p>
        </div>

        {/* Social Media */}
        <div className={styles.footerSocial}>
          <h4>Follow Us</h4>
          <div className={styles.socialIcons}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} MaidMatch. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
